import * as React from "react";

/**
 * Used for background effect on cell buttons in Kernel editor.
 * Due to these being rendered in shadow DOM and incompatibility with
 * styled-components CSS cascades, styles must be applied inline or within
 * renderShadowDOM.tsx global styles.
 */
export const CircularHover = React.memo(() => (
  <svg
    viewBox="0 0 100 100"
    style={{ overflow: "visible" }}
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      cx="50"
      cy="50"
      r="50"
      transform="scale(1.4)"
      fill="transparent"
      className="circular-hover"
      style={{ transformOrigin: "center center" }}
    />
  </svg>
));
